export const CTRC = {
    wizard: {
        termsAndConditionsAgree: "I agree to the Terms & Conditions and to be contacted via electronic communications, including SMS messages, regarding my storage account and service updates."
    }
};